import { FC, ReactElement } from 'react'

import { EmployeesFilterContainer } from '../../../containers'
import {
    setOnlyShowShiftsWithAbsence,
    setOnlyShowShiftsWithOpenLeaveOfAbsence,
    setShowEmploymentTypes,
} from '../../../redux/@interface/globalFilters/globalFiltersReducer'
import { useTypedDispatch, useTypedSelector } from '../../../redux/store'

const ConnectedEmployeesFilter: FC = (): ReactElement => {
    const dispatch = useTypedDispatch()

    const onlyShowShiftsWithAbsence = useTypedSelector(state => state.globalFiltersReducer.onlyShowShiftsWithAbsence)
    const onlyShowShiftsWithOpenLeaveOfAbsence = useTypedSelector(state => state.globalFiltersReducer.onlyShowShiftsWithOpenLeaveOfAbsence)
    const showEmploymentTypes = useTypedSelector(state => state.globalFiltersReducer.showEmploymentTypes)

    const handleShowAllShiftsWithAbsencesChange = (show: boolean) => {
        dispatch(setOnlyShowShiftsWithAbsence(show))
    }

    const handleShowAllShiftsWithLeaveOfOpenAbsencesChange = (show: boolean) => {
        dispatch(setOnlyShowShiftsWithOpenLeaveOfAbsence(show))
    }

    const handleShowEmploymentTypesChange = (show: boolean) => {
        dispatch(setShowEmploymentTypes(show))
    }

    return (
        <EmployeesFilterContainer
            showAllShiftsWithAbsences={onlyShowShiftsWithAbsence}
            showAllShiftsWithOpenLeaveOfAbsences={onlyShowShiftsWithOpenLeaveOfAbsence}
            showEmploymentTypes={showEmploymentTypes}
            onShowAllShiftsWithAbsencesChange={handleShowAllShiftsWithAbsencesChange}
            onShowAllShiftsWithOpenLeaveOfAbsencesChange={handleShowAllShiftsWithLeaveOfOpenAbsencesChange}
            onShowEmploymentTypesChange={handleShowEmploymentTypesChange}
        />
    )
}

export default ConnectedEmployeesFilter
